import { Text } from "@/components/ui/baseUi/text"
import { MediaType } from "@/modules/common/media/mediaTypes"
import { cn } from "@/modules/lib/utils"
import { ImageThumbnail } from "@/modules/programs/components/programSession/blocks/mediaThumbnails/mediaImageThumbnail"
import { PdfThumbnail } from "@/modules/programs/components/programSession/blocks/mediaThumbnails/mediaPdfThumbnail"
import { VideoThumbnail } from "@/modules/programs/components/programSession/blocks/mediaThumbnails/mediaVideoThumbnail"
import { VimeoThumbnail } from "@/modules/programs/components/programSession/blocks/mediaThumbnails/mediaVimeoThumbnail"
import { YouTubeThumbnail } from "@/modules/programs/components/programSession/blocks/mediaThumbnails/mediaYoutubeThumbnail"
import type { SessionMediaItemEntity } from "@/modules/sessions/entities/sessionBlockMediaEntity"
import { word } from "@modules/core/utils/i18n"

type Props = {
  medias: SessionMediaItemEntity[]
  displayDetailedEvents: boolean
  className?: string
} & React.ComponentProps<"div">

export function MediaDetailsInEvent({ medias, displayDetailedEvents, className, ...props }: Props) {
  return (
    <div className={cn("flex flex-col gap-1", className)} {...props}>
      <Text fontStyle="LS" className="text-textDefault-body uppercase">
        {word("sessionForm.blocks.media")}
      </Text>
      <div className="flex flex-row flex-wrap gap-1">
        {medias.map((media, index) => (
          <div
            key={index}
            className={cn("relative flex overflow-hidden rounded-lg", {
              "aspect-square w-full": displayDetailedEvents,
              "h-15 w-15": !displayDetailedEvents,
            })}
          >
            {media.type === MediaType.S3_VIDEO ? (
              <VideoThumbnail url={media.url} />
            ) : media.type === MediaType.S3_IMAGE ? (
              <ImageThumbnail url={media.url} />
            ) : media.type === MediaType.S3_PDF ? (
              <PdfThumbnail displayDetailedEvents={displayDetailedEvents} />
            ) : media.type === MediaType.YOUTUBE ? (
              <YouTubeThumbnail url={media.url} />
            ) : media.type === MediaType.VIMEO ? (
              <VimeoThumbnail url={media.url} />
            ) : null}
          </div>
        ))}
      </div>
    </div>
  )
}
